const state = {
  // 设备
  ganttDevice: {},
  // 任务id
  ganttPlan: {},
  // 查看模式
  ganttEditMode: false,
  // 剪切任务
  cutPlan: null,
  // 设备配置
  deviceConfigForPlan: {}
};
const mutations = {
  SET_GANTT_DEVICE: (_state, data) => {
    _state.ganttDevice = data;
  },
  SET_GANTT_PLAN: (_state, data) => {
    _state.ganttPlan = data;
  },
  SET_GANTT_Edit_Mode: (_state, data) => {
    _state.ganttEditMode = data;
  },
  SET_CUT_PLAN: (_state, data) => {
    _state.cutPlan = data;
  },
  SET_DEVICE_CONFIG: (_state, data) => {
    const config = {
      ..._state.deviceConfig,
      ...data
    };
    _state.deviceConfigForPlan = null;
    _state.deviceConfigForPlan = config;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
